import firebase from 'firebase/app'

let postcardQueryLimit = 5;
let nextPostcardQuery = null;
export default {

    namespaced: true,

    state: {
        postcards:[],
        userPostcards:{},
        activeUserPostcards:[],
        postcardSort:'latest-postcard',
        postcardSortExp:['date', 'desc'],
        activePostcard:null,
        postcardScrollPosition:0,
        userPostcardScrollPosition:0,
        postcardCount:0
    },

    getters: {
        activePostcard:(state) => {
            return state.activePostcard;
        },
        activeUserPostcards:(state) => {
            return state.activeUserPostcards;
        },
        postcardScrollPosition:(state) => {
            return state.postcardScrollPosition;
        },
        postcardCount:(state) => {
            return state.postcardCount;
        }
    },

    actions: {

        getPostcardCount({commit}) {
            console.log(`store.actions.postcards.getPostcardCount() load stats:`);
            // get postcard count
            let postcardCountRef = this.$fbdb.collection('postcards').doc('statistics');
            return postcardCountRef.get()
                .then((docSnapshot) => {
                    let stats = docSnapshot.data();
                    console.dir(stats);
                    commit('updatePostcardCount', stats.postcardCount);
                    return Promise.resolve(stats)
                })
                .catch(err => { throw (err) })
        },
        
        getPostcards({state, commit}, sort) {
            console.log(`store.actions.postcards.getPostcards()`);
            // paginate postcard request over postcardQueryLimit
            let postcardsRef = this.$fbdb.collection('postcards').limit(postcardQueryLimit);
            commit('updateSort', sort);
            return postcardsRef
                .orderBy(...state.postcardSortExp)
                .get()                
                .then((QuerySnapshot) => {
                    let postcards = QuerySnapshot.docs.map(doc => Object.assign({_id: doc.id}, doc.data()));
                    commit('setPostcards', postcards);
                    // update next query
                    if (postcardQueryLimit == postcardQueryLimit) {
                        nextPostcardQuery = this.$fbdb.collection('postcards')
                            .orderBy(...state.postcardSortExp)
                            .startAfter(QuerySnapshot.docs[QuerySnapshot.docs.length - 1])
                            .limit(postcardQueryLimit);
                    }
                    return Promise.resolve(postcards);
                })
                .catch(err => { throw (err) })
        },

        getNextPostcards({state, commit}) {
            if (!nextPostcardQuery) {
                console.log(`store.actions.postcards.getPostcards() nextPostcardQuery is undefined`);
                return;
            }
            console.log(`store.actions.postcards.getPostcards()`);
            return nextPostcardQuery.get()
                .then((QuerySnapshot) => {
                    let postcards = QuerySnapshot.docs.map(doc => Object.assign({_id: doc.id}, doc.data()));
                    commit('addPostcards', postcards);
                    // update next qurey
                    if (QuerySnapshot.docs.length == postcardQueryLimit) {
                        nextPostcardQuery = this.$fbdb.collection('postcards').orderBy(...state.postcardSortExp)
                            .startAfter(QuerySnapshot.docs[QuerySnapshot.docs.length - 1])
                            .limit(postcardQueryLimit);
                    } else {
                        nextPostcardQuery = null;
                    }
                    return Promise.resolve(postcards);
                })
                .catch(err => { throw (err) })
        },

        getPostcard({commit, state}, postcard_id) {
            console.log(`store.actions.postcards.getPostcard() ${postcard_id}`);
            let postcardsRef = this.$fbdb.collection('postcards').doc(postcard_id);
            return postcardsRef.get() 
                .then((docSnapshot) => {
                    if (docSnapshot.exists) {
                        commit('setActivePostcard', Object.assign({'_id':docSnapshot.id}, docSnapshot.data()) || {});
                        return Promise.resolve(state.activePostcard);
                    }
                    console.log(`store.actions.postcards.getPostcard() no document found for postcard id ${postcard_id}`);
                    return Promise.reject(`No postcard found for id ${postcard_id}`);
                })
                .catch(err => { throw (err) })
        },

        getPostcardsByUser({state, commit}, user_id) {
            console.log(`store.actions.postcards.getPostcardsByUser() user id ${user_id}`);
            if (state.userPostcards[user_id]) {
                commit('updateActiveUserPostcards', state.userPostcards[user_id]);
                console.log(`store.actions.postcards.getPostcardsByUser() set user scroll position ${state.userPostcards[user_id].ScrollPosition}`);
                commit('updateActiveUserPostcardScrollPosition', state.userPostcards[user_id].ScrollPosition);
                return Promise.resolve(state.userPostcards[user_id]);
            }
            let postcardsRef = this.$fbdb.collection('postcards');
            return postcardsRef
                .where('owner', '==', user_id)
                .orderBy(...state.postcardSortExp)
                .get()
                .then((querySnapshot) => {
                    let postcards = querySnapshot.docs.map(doc => Object.assign({_id: doc.id}, doc.data()));
                    console.log(`store.actions.postcards.getPostcardsByUser() ${postcards.length} postcards loaded for user ${user_id}`);
                    commit('updateUserPostcards', postcards, user_id);
                    commit('updateActiveUserPostcards', postcards);
                    return Promise.resolve(postcards);
                })
        },

        getRandomPostcard({state, commit}) {
            let iRandom = Math.floor(Math.random() * (state.postcardCount - 1));
            let randId = this.$fbdb.collection('postcards').doc().id;
            console.log(`store.actions.postcards.getRandomPostcard() iRandom ${randId}`);
            let postcardsRef = this.$fbdb.collection('postcards')
                            .where('__name__', '>=', randId)
                            .orderBy('__name__')
                            .limit(1);
            return postcardsRef.get() 
                .then((querySnapshot) => {
                    if (querySnapshot.docs.length > 0) {
                        console.log(`store.actions.postcards.getRandomPostcard() ${querySnapshot.docs.length} results`);
                        let doc = querySnapshot.docs[0];
                        console.log(`store.actions.postcards.getRandomPostcard() doc id ${doc.__name__}`);
                        console.dir(doc);
                        commit('setActivePostcard', Object.assign({'_id':doc.id}, doc.data()) || {});
                        return Promise.resolve(state.activePostcard);
                    }
                    console.log(`store.actions.postcards.getRandomPostcard() no document found for postcard index ${iRandom}`);
                    return Promise.reject(`No postcard found for postcard index ${iRandom}`);
                })
                .catch(err => { throw (err) })
        },

        createPostcard({ commit, state, dispatch }, postcard) {
            console.log(`store.actions.postcards.createPostcard()`);
            console.dir(postcard);
            let postcardsRef = this.$fbdb.collection('postcards');
            return postcardsRef.add(postcard)
                .then((doc) => {
                    console.log(`store.actions.postcards.createPostcard() doc created`);
                    return doc.get()
                        .then((docSnapshot) => {
                            let postcard = Object.assign({ '_id': docSnapshot.id }, docSnapshot.data());
                            console.log(`store.actions.postcards.createPostcard() created`);
                            console.dir(postcard);
                            if (state.postcards.length > 0) {
                                commit('addPostcard', postcard);
                                commit('sortPostcards', state.postcardSort);
                            }                            
                            // update postcard count
                            return dispatch('incrementPostcardCount', 1)
                                .then((count) => {
                                    console.log(`store.actions.postcards.createPostcard() counter incremented to ${count}`);
                                    return Promise.resolve(postcard)
                                })
                                .catch(err => { throw (err) })
                        })
                        .catch(err => { throw (err) })
                })
                .catch(err => { throw (err) })
        },

        updatePostcard({ commit, state }, postcard) {
            console.log(`store.actions.postcards.updatePostcard()`);
            let postcardsRef = this.$fbdb.collection('postcards').doc(postcard._id);
            return postcardsRef.update(postcard)
                .then((doc) => {
                    console.log(`store.actions.postcards.updatePostcard() update response:`);
                    console.dir(doc);
                    return postcardsRef.get()
                        .then((docSnapshot) => {
                            let postcard = docSnapshot.data();
                            commit('updatePostcard', postcard);
                            commit('sortPostcards', state.postcardSort);
                            return Promise.resolve(postcard);
                        })
                        .catch(err => { throw (err) })
                })
                .catch(err => { throw (err) })
        },

        updatePostcardPhotos({ commit, state }, postcard) {
            console.log('store.actions.postcards.updatePostcardPhotos()');
            console.dir(postcard);
            let postcardRef = this.$fbdb.collection('postcards').doc(postcard._id);
            return postcardRef.update({ photos: postcard.photos })
                .then(() => {
                    commit('updateActivePostcard', postcard);
                    return Promise.resolve(state.activePostcard);
                })
                .catch(err => { throw (err) })
        },

        delete({commit, dispatch}, postcard) {
            console.log(`store.actions.postcards.delete() [${postcard._id}]`);
            console.dir(postcard);
            let postcardRef = this.$fbdb.collection('postcards').doc(postcard._id);
            return postcardRef.collection('photos').get()
                .then(querySnapshot => {
                    if (querySnapshot.empty) {
                        return postcardRef.delete()
                            .then(() => {
                                commit('delete', postcard._id);
                                return dispatch('incrementPostcardCount', -1);
                            })
                            .catch(err => { throw (err) })
                    } else {
                        // delete photos first
                        return dispatch('photos/deletePhotos', querySnapshot, { root: true })
                            .then(response => {
                                console.log(`store.actions.postcards.delete() delete photos response [${response}]`);
                                return postcardRef.delete()
                                    .then(() => {
                                        commit('delete', postcard._id);
                                        return dispatch('incrementPostcardCount', -1);
                                    })
                            })
                            .catch(err => { throw (err) })
                    }
                })
                .catch(err => { throw (err) })
        },

        incrementPostcardCount({commit}, val) {
            console.log(`store.actions.postcards.incrementPostcardCount() increment by ${val}:${typeof(val)}`);
            // update postcard count
            let statsRef = this.$fbdb.collection('postcards').doc('statistics');
            let increment = firebase.firestore.FieldValue.increment(val);
            return statsRef.update({'postcardCount': increment})
                .then(() => {
                    return statsRef.get()
                        .then((statsSnapshot) => {
                            let stats = statsSnapshot.data();
                            commit('updatePostcardCount', stats.postcardCount);
                            console.log(`store.actions.postcards.incrementPostcardCount() postcard count #${stats.postcardCount} incremented by ${val}`);
                            return Promise.resolve(true);
                        })
                        .catch(err => { throw (err) })
                })
                .catch(err => { throw (err) })
        },

        setActivePostcard({commit, dispatch}, postcard) {
            commit('setActivePostcard', postcard);
            // load postcard photos into activPhotos
            return dispatch('photos/getPostcardPhotos', postcard._id, {root:true})
                .then((photos) => {
                    return Promise.resolve(photos);
                })
                .catch(err => { throw (err) })
        }
    },

    mutations: {

        updatePostcardCount(state, count) {
            console.log(`store.mutations.postcards.updatePostcardCount() count ${count}`);
            state.postcardCount = count;
        },

        setPostcards(state, postcards) {
            state.postcards = postcards;
        },

        addPostcards(state, postcards) {
            state.postcards = state.postcards.concat(postcards);
        },

        setActivePostcard(state, postcard) {
            state.activePostcard = postcard;
        },

        addPostcard(state, postcard) {
            state.postcards.push(postcard);
        },

        updateUserPostcards(state, postcards, user_id) {
            if (!user_id) {
                user_id = postcards[0].owner;
            }
            console.log(`store.mutations.postcards.updateUserPostcards() ${postcards.length} postcards for user id ${user_id}`);
            state.userPostcards[user_id] = postcards;
        },

        updateActiveUserPostcards(state, postcards) {
            state.activeUserPostcards = postcards;
        },

        updateActiveUserPostcardScrollPosition(state, position) {
            state.userPostcardScrollPosition = position;
        },

        updatePostcard(state, postcard) {
            let i = state.postcards.findIndex(p => p._id == postcard._id);
            if (i > -1) {

                state.postcards[i] = postcard;
            } 
            else if (state.postcards.length === 0) 
            {
                console.warn(`store.mutations.postcards.updatePostcard() state.postcards is empty`);
            } 
            else 
            {
                throw ({message: `Could not find postcards [${postcard._id}] in postcards[]`})
            }
        },

        updateActivePostcard(state, postcard) {
            state.activePostcard = postcard;
            if (state.postcards.length > 0) {
                let i = state.postcards.findIndex(p => p._id == postcard._id);
                if (i > -1) {
                    state.postcards[i] = postcard;
                } 
                else 
                {
                    throw ({message: `Could not find postcards [${postcard._id}] in postcards[]`})
                }
            }
        },

        updateSort(state, sort) {
            state.postcardSort = sort;
            if (state.postcardSort == 'latest') 
            {
                state.postcardSortExp = ['date', 'desc'];
            }
            else if (state.postcardSort == 'earliest') 
            {
                state.postcardSortExp = ['date', 'asc'];
            }
            else if (state.postcardSort == 'recent') 
            {
                state.postcardSortExp = ['Created_date', 'desc'];
            }
            else if (state.postcardSort == 'random') 
            {
                state.postcardSortExp = ['date', 'desc'];
            }
            //commit('sortPostcards', sort);
        },

        sortPostcards(state, sort) {
            console.log(`store.mutations.postcards.sortPostcards() sort [${sort}]`);
            let sortFunction;
            if (sort === 'first-added') 
            {
                sortFunction = (n1, n2) => {
                    return (n1.Created_date.seconds > n2.Created_date.seconds) ? 1 : -1;
                }
            } 
            else if (sort === 'first-postcard') 
            {
                sortFunction = (n1, n2) => {
                    return (n1.date.seconds > n2.date.seconds) ? 1 : -1;
                }
            } 
            else if (sort === 'latest-added') 
            {
                sortFunction = (n1, n2) => {
                    return (n1.Created_date.seconds < n2.Created_date.seconds) ? 1 : -1;
                }
            } 
            else if (sort === 'latest-postcard') 
            {
                sortFunction = (n1, n2) => {
                    return (n1.date.seconds < n2.date.seconds) ? 1 : -1;
                }
            } 
            else 
            {
                console.warn(`store.mutations.postcards.sortPostcards() No handler for sort [${sort}]`);
                return;
            }
            state.postcards.sort(sortFunction);
            state.postcardSort = sort;
        },

        setScrollPosition(state, position) {
            console.log(`store.mutations.postcards.setScrollPosition() position ${position}`);
            state.postcardScrollPosition = position;
        },

        setUserScrollPosition(state, {position, user_id}) {
            console.log(`store.mutations.postcards.setUserScrollPosition() position ${position} user id ${user_id}`);
            state.userPostcards[user_id].ScrollPosition = position;
        },

        delete(state, postcard_id) {
            let i = state.postcards.findIndex(n => n._id == postcard_id);
            console.log(`store.mutations.postcards.delete() postcard id [${postcard_id}] at index [${i}]`);
            if (i > -1) {
                state.postcards.splice(i, 1);
            } else {
                throw ({ message: `Could not find postcard by id [${postcard_id}]`})
            }
        }

    }
}

